import React, {useState} from 'react';
import {Button} from 'rsuite';
import ErrorPAgeImage from '../../img/error-page.svg'
import './pageNotFound.scss';
import SupportElement from "../panel/elements/support_element/supportElement";
import AuthService from "../../services/auth.service";

const PageNotFound = () => {
    const supportElements = AuthService.getSupportElements();
    //if(){
    localStorage.setItem("error", '');
    //}
    const [showing, setShowing] = useState(false);
    return (
        <>
            <div style={{paddingBottom: '1rem'}} className="error-page">
                <div className="form-container"
                     style={{marginTop: '2rem', backgroundColor: 'white'}}>

                    <div className="form-container_card"
                         style={{backgroundColor: 'white'}}>
                        <div className="image"><img src={ErrorPAgeImage} alt="error-page"/></div>


                        <div className="title">متاسفانه صفحه دچار مشکل فنی شده‌</div>
                        <div className="content">
                            <p className="content-p">
                                لطفا یکبار صفحه رو بروزرسانی کنید. در صورت عدم رفع مشکل
                                به پشتیبانی برنامه اطلاع دهید
                            </p>

                        </div>


                        <div className="d-flex  ">


                            <div className="w-50 text-bold text-start"
                                 style={{fontSize: '1rem', textAlign: 'start', marginTop: '.5rem'}}>


                                <Button appearance="ghost"
                                        className=" btn-get-regime button-footer"
                                        block
                                        onClick={() => {
                                            setShowing(!showing)
                                        }

                                        }
                                        style={{marginTop: '1rem', marginBottom: '1rem', color: '#25AF9E'}}>
                                    تماس با پشتیبانی


                                </Button>
                                <div style={{display: (showing ? 'block' : 'none')}}>
                                    <SupportElement expanded={showing}
                                                    supportElements={supportElements ? supportElements : ''}/>
                                </div>
                            </div>

                            <div className="w-50 text-bold text-start" style={{
                                fontSize: '1rem',
                                textAlign: 'start',
                                marginRight: '1rem',
                                marginLeft: '2rem',
                                marginTop: '.5rem'
                            }}>
                                <Button appearance="primary"
                                        className="btn-get-regime button-footer"
                                        block
                                        onClick={e => window.location.replace('/')}
                                        style={{marginTop: '1rem', marginBottom: '1rem', backgroundColor: '#25AF9E'}}>
                                    بروزرسانی صفحه

                                </Button>


                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </>

    );

}


export default PageNotFound;